<template>
  <ScaleTransition>
    <div
      v-if="getEditableComment"
      v-click-outside="closeBox"
      class="comment-box smooth-shadow"
      :style="{
        top: `${getEditableComment.screenLocation.y + 10}px`,
        left: `${getEditableComment.screenLocation.x - 10}px`,
      }"
    >
      <div class="box-header">
        <h4 class="title">Comment</h4>
        <Icon type="button" size="18" @click="closeBox">clear</Icon>
      </div>
      <textarea
        v-model="message"
        class="comment"
        placeholder="Enter your comment here"
      />
      <div class="button-area">
        <button
          v-if="!isLoading"
          class="btn-option delete"
          @click="deleteComment"
        >
          <Icon size="18">delete</Icon>
          Delete
        </button>
        <button v-if="!isLoading" class="btn-option" @click="saveComment">
          <Icon size="18">check</Icon>
          Save Comment
        </button>
        <Spinner v-if="isLoading" small />
      </div>
    </div>
  </ScaleTransition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CommentModel, {
  Properties,
  Geometry,
  geometryTypes,
} from "@/models/Comment.model";
import { ScaleTransition } from "vue2-transitions";

export default {
  components: {
    ScaleTransition,
  },
  data() {
    return {
      isLoading: false,
      comment: null,
      message: null,
    };
  },
  computed: {
    ...mapGetters("Comments", [
      "getEditableComment",
      "getCommentById",
      "getDashboardId",
    ]),
  },
  methods: {
    ...mapActions("Comments", [
      "setEditComment",
      "addComment",
      "updateComment",
      "removeComment",
    ]),
    closeBox() {
      // this.$emit("close");
      console.log("closing...");
      this.setEditComment(null);
    },
    async saveComment() {
      if (this.comment && this.comment.comment_id) {
        await this.updateComment({
          comment_id: this.comment.comment_id,
          properties: {
            ...this.comment.properties,
            message: this.message,
          },
        });
      } else {
        const comment = new CommentModel({
          properties: new Properties({
            message: this.message,
            dashboard_id: this.getDashboardId,
          }),
          geometry: new Geometry({
            type: this.getEditableComment.geometry.type,
            coordinates: this.getEditableComment.geometry.coordinates,
          }),
        });
        await this.addComment(comment);
      }
      this.closeBox();
    },
    async deleteComment() {
      if (this.getEditableComment.comment_id) {
        this.removeComment(this.getEditableComment.comment_id);
        this.closeBox();
      } else {
        this.closeBox();
      }
    },
  },
  watch: {
    getEditableComment: {
      immediate: true,
      handler() {
        this.message = null;
        if (this.getEditableComment && this.getEditableComment.comment_id) {
          this.comment = this.getEditableComment;
          this.message = this.comment ? this.comment.properties.message : null;
        }
      },
    },
  },
  mounted() {
    this.message = null;
  },
};
</script>

<style lang="scss" scoped>
.comment-box {
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  height: auto;
  padding: 10px;
  background: var(--color-secondary);
  border-radius: 5px;
  z-index: 100;
  display: flex;
  flex-direction: column;

  .title {
    font-weight: bold;
  }

  .comment {
    border: 0;
    background-color: var(--color-default-background);
    padding: 10px;
    color: var(--font-color);
    border-radius: 3px;
    height: 100px;
    min-width: 250px;
  }

  .box-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  .button-area {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding: 5px 0;

    .btn-option {
      display: flex;
      align-items: center;
      border: 0;
      padding: 10px;
      background: transparent;
      color: var(--color-primary);
      border-radius: 5px;
      outline: none;

      i {
        margin-right: 5px;
      }

      &:hover {
        cursor: pointer;
        background-color: var(--color-primary-light);
      }

      &.delete {
        color: rgb(221, 106, 12);

        &:hover {
          background: var(--border-color);
        }
      }
    }
  }

  &:after {
    position: absolute;
    content: "";
    top: -20px;
    left: 0px;
    right: 0;
    width: 10px;
    height: 10px;
    background-color: var(--color-primary);
    border-radius: 50px;
    border: 2px solid var(--color-primary-light);
  }
}
</style>
